<template>
  <drm-group-update-list :selectedItem="videoInfo" :handleBack="handleBack" />
</template>

<script>
// Components
import DrmGroupUpdateList from '@/components/DrmGroupUpdateList.vue'

export default {
  name: 'VideoPlayerDRMSecurity',
  components: {
    DrmGroupUpdateList,
  },
  inject: ['video'],
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
  },
  computed: {
    videoInfo() {
      return this.$store.state.video.video
    },
  },
}
</script>
